import GenericController from './../generic.controller'

export default class Controller extends GenericController {

    constructor(...args) {

        super(...args);

        this.zones = null;
        this.stateKeys = [this.gettext('sensor_watch_alarm'), this.gettext('supervision_alarm'), this.gettext('battery_low'),
            this.gettext('tamper_alarm'), this.gettext('zone_24H_alarm'), this.gettext('not_ready'), this.gettext('Open'),
            this.gettext('open')];
        this.ACTIONS_TEXT = [this.gettext('Bypass'), this.gettext('Non Bypass'), this.gettext('Unknown device type')];
        this._statisticGraphChartBindToName = 'THPchart';
        this.areas = [];
        this.$scope.currentPromise = this.getZonesAndAreas();

        this.bypass = this.$rootScope.$on('bypass', (e, eventObj) => {
            this._onSocketEventUpdateZoneAttribute(eventObj, 'bypass', 'Zone', this._findZone.bind(this));
        });

        this.zoneTrouble = this.$rootScope.$on('zone_trouble', (e, eventObj) => {
            this._onSocketEventUpdateZoneAttribute(eventObj, 'zone_trouble', 'Zone', this._findZone.bind(this));
        });

        this.tamper = this.$rootScope.$on('tamper', (e, eventObj) => {
            this._onSocketEventUpdateZoneAttribute(eventObj, 'tamper_alarm', 'Zone', this._findZone.bind(this));
        });

        this.supervisionZoneAlarm = this.$rootScope.$on('supervised_radio_zone_alarm', (e, eventObj) => {
            this._onSocketEventUpdateZoneAttribute(eventObj, 'supervision_alarm', 'Zone', this._findZone.bind(this))
        });

        this.socketEventReference = this.$rootScope.$on('socketEvent', (e, event) => {
            this.getZonesAndAreas();
        });

        this.$element.on('$destroy', () => {
            this.closeModal('zoneGraphModal');
            this.closeModal('HomeAutomationStatisticsModal');
            this.closeModal('AirQualityStatisticsModal');
            this.closeModal('GenericStatisticsModal');
            this.bypass();
            this.zoneTrouble();
            this.tamper();
            this.supervisionZoneAlarm();
            this.socketEventReference();
        });

    }

    _updateZone(zone) {
        _.merge(this.zones, zone)
        this.$scope.$apply();
    }

    _findZone(zoneId) {
        return _.find(this.zones, {'id': zoneId})
    }

    setZoneName(zoneObj) {
        this.askUserCode()
            .then(userCode => {
                if (userCode) {
                    this.ModalDialogService.isModalClosed = true;
                    if (zoneObj.name) {
                        this.$scope.currentPromise = this._PanelsService.changePanelZone(this.panelId, zoneObj, userCode).then(resp => {
                            this.popMessage(zoneObj.name + ' ' + this.updateOKText);
                            let zone = resp.data;
                            _.merge(this.zones, zone);
                            this.UserCodeService.saveUserCode(userCode);
                        }).finally(this.ModalDialogService.isModalClosed = false)
                    } else {
                        this.$state.reload();
                    }
                }
            }).catch(() => {
            this.$state.reload();
        });
    }

    getZonesAndAreas() {
        return this.getZonesConfigList() && this.getAreasConfigList();
    }

    getAreasConfigList() {

        return super.getAreasConfigList().then(resp => {
            this.areas = resp;
        })
    }

    getAreasName(areasId) {

        if (this.areas.length > 0) {

            let areasNames = [];

            for (let currentAreaID of areasId) {

                areasNames.push(_.find(this.areas, {id: currentAreaID}).name)
            }

            return areasNames.join().replace(/,/g, '\n');
        }
    }

    getZonesConfigList() {

        return super.getZonesConfigList()
            .then(resp => {
                this.zones = resp;
            })
            .catch(() => {
            });
    }

    isZoneEmpty() {

        if (!this.zones) {

            return this.zones
        }

        return this.zones.length == 0;
    }

    getDeviceDescription(id) {

        let deviceType = this.DEVICE_TYPE[id];

        if (deviceType) {
            return deviceType.deviceTypeDescription;
        } else {
            return 'Unknown device type'
        }
    }

    getStateList(zoneIndex) {

        let stateList = '';
        let openText = null;


        for (let statesIndex = 0; statesIndex < this.stateKeys.length; statesIndex++) {

            let key = this.stateKeys[statesIndex];

            if (this.zones[zoneIndex]['state'] == true) {
                openText = this.getTranslatableText('Open');
            }

            if (this.zones[zoneIndex][key] == true) {
                stateList += this.getTranslatableText(key).split('_').join(' ') + ', ';
            }
        }
        if (openText) {
            stateList = openText + ', ' + stateList;
        }

        return stateList.slice(0, -2);
    }

    bypassToggle(zoneId, bypass) {

        this.$scope.currentPromise = super.setZoneBypass(zoneId, !bypass).then(() => {
            this.getZonesAndAreas();
        });
        // .catch(err => {
        //     console.log(err);
        // });
    }

    loadChosenGraph(graphTypeStr, offset = 0) {
        this.showModal('zoneGraphModal');
        this._setTimeoutGraphLoading(graphTypeStr, offset, this.getDectZoneMeasurements);
    }

    loadGenericStatisticsChosenGraph(graphTypeStr, offset = 0) {
        this.showModal('zoneGraphModal');
        this._setTimeoutGraphLoading(graphTypeStr, offset, this.getZoneGenericStatisticsMeasurements);
    }

}


/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/zones.component/controller.js
 **/